import { render, staticRenderFns } from "./BiographyCover.vue?vue&type=template&id=670bb63c&scoped=true"
import script from "./BiographyCover.vue?vue&type=script&lang=js"
export * from "./BiographyCover.vue?vue&type=script&lang=js"
import style0 from "./BiographyCover.vue?vue&type=style&index=0&id=670bb63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670bb63c",
  null
  
)

export default component.exports